import { Observable } from "rxjs";
import st from "lib/utils/index";
import { ProductsRepository } from "lib/repositories/index";
import { createResourceInstance } from "modules/utils/index";
import { combineEpics } from "redux-observable";
import { replaceCompanyRoute } from "modules/app/actions";
import createProductsFiltersInstance from "./createProductsFiltersInstance";

export const INITIALIZE_VIEW = "products/ProductsListView/INITIALIZE_VIEW";
export const DESTROY_VIEW = "products/ProductsListView/DESTROY_VIEW";
export const LOAD_PRODUCTS = "products/ProductsListView/LOAD_PRODUCTS";
export const FETCH_PRODUCTS = "products/ProductsListView/FETCH_PRODUCTS";
export const FETCH_PRODUCTS_START = "products/ProductsListView/FETCH_PRODUCTS_START";
export const FETCH_PRODUCTS_SUCCESS = "products/ProductsListView/FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILURE = "products/ProductsListView/FETCH_PRODUCTS_FAILURE";
export const CHANGE_PAGINATION = "orders/ProductsListView/CHANGE_PAGINATION";
export const SET_PAGINATION = "orders/ProductsListView/SET_PAGINATION";
export const SET_FILTERS = "orders/ProductsListView/SET_FILTERS";
export const CHANGE_FILTERS = "orders/ProductsListView/CHANGE_FILTERS";

export const stateSelector = (state) => state.products.ProductsListView;

const resourceInstance = createResourceInstance({
  LOAD: LOAD_PRODUCTS,
  FETCH: FETCH_PRODUCTS,
  FETCH_START: FETCH_PRODUCTS_START,
  FETCH_SUCCESS: FETCH_PRODUCTS_SUCCESS,
  FETCH_FAILURE: FETCH_PRODUCTS_FAILURE,
  stateSelector,
  stateKey: "products",
  getModel: ({ offset, limit, filters }) => {
    return ProductsRepository.search({ offset, limit, ...filters });
  },
});

const filtersInstance = createProductsFiltersInstance({
  SET_FILTERS,
  getInitialFilters: () => ({}),
});

const limit = parseInt(localStorage.getItem("productsLimit"), 10) || 10;
const initialState = {
  products: resourceInstance.initialState,
  offset: 0,
  limit: limit,
  ...filtersInstance.initialState,
};

const reducers = {
  ...resourceInstance.reducersMap,
  ...filtersInstance.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,

  [SET_PAGINATION]: (state, { offset = state.offset, limit = state.limit }) => ({
    ...state,
    offset,
    limit,
  }),
};

const viewEpics = [
  ...resourceInstance.epics,
  ...filtersInstance.epics,

  (actions$) => Observable.of(fetchProducts()),

  (actions$) => actions$.ofType(CHANGE_FILTERS).map(({ filters }) => setFilters(filters)),

  (actions$) => actions$.ofType(CHANGE_PAGINATION).map(({ offset, limit }) => setPagination({ offset, limit })),

  (actions$) =>
    actions$.ofType(CHANGE_FILTERS).merge(actions$.ofType(CHANGE_PAGINATION)).debounceTime(300).mapTo(fetchProducts()),

  (actions$, { getState }) =>
    actions$
      .ofType(SET_FILTERS)
      .debounceTime(500)
      .map(() => {
        const { filters } = stateSelector(getState());
        const query = filtersInstance._serializeFiltersToLocationQuery(filters);
        return replaceCompanyRoute({ pathname: "/products", query });
      }),
];

const epics = [
  (actions$, store) =>
    actions$
      .ofType(INITIALIZE_VIEW)
      .concatMap(() => combineEpics(...viewEpics)(actions$, store).takeUntil(actions$.ofType(DESTROY_VIEW))),
];

export const { setFilters } = filtersInstance.actions;

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export function setPagination({ offset, limit }) {
  return { type: SET_PAGINATION, offset, limit };
}

export function changePagination({ offset, limit }) {
  return { type: CHANGE_PAGINATION, offset, limit };
}

export function setParamsWithPaginationQuery({ o = initialState.offset, l = initialState.limit, ...query } = {}) {
  return (dispatch) => {
    dispatch(setPagination({ offset: +o, limit: +l }));
    dispatch(fetchProducts());
  };
}

export function changeFilters(filters) {
  return { type: CHANGE_FILTERS, filters };
}

export function destroyView() {
  return { type: DESTROY_VIEW };
}

export function changeFiltersAndResetOffset(filters) {
  return (dispatch) => {
    dispatch(changePagination({ offset: 0 }));
    dispatch(changeFilters(filters));
  };
}

export const { load: loadProducts, fetch: fetchProducts } = resourceInstance.actions;

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/products/ProductsListView/index.js